//OPEN PACKAGES DROPDOWN

var packagePurchaseForm = $('.package-purchase-form form'),
    packageDropdown = packagePurchaseForm.find('.package-selector'),
    packageToggleBlock = packageDropdown.find('.selector-active'),
    packageInput = packageDropdown.find('input[name=select-package]'),
    packagePurchaseFormSlick = packagePurchaseForm.find('.purchase-carousel');

var setSlickHeight = function(slick) {

    var slickList = slick.find('.slick-list'),
        activeSlide = slickList.find('.slick-active');

    slickList.css('height', activeSlide.height());

};

var packageDropdownToggle = function(close) {

    var packageList = packageDropdown.find('.package-list'),
        packageWrap = packageList.find('.package-wrap');

    if(close){

        packageList.css('height', packageWrap.outerHeight()).css('height', 0).one(transitionEvent, function (e) {
            packageList.removeAttr('style');
            packageDropdown.removeClass('is-active');
        });

    }else {

        packageDropdown.addClass('is-active');

        packageList.css('height', 0).css('height', packageWrap.outerHeight()).one(transitionEvent, function (e) {
            packageList.removeAttr('style');
        })

    }
};

$('body').on('click', function (e) {

    if(!($(e.target).closest('.package-selector').length > 0) && $(e.target).closest('.package-selector').hasClass('is-active')){
        packageDropdownToggle(true);
    }

});

packageToggleBlock.on('click', function (e) {

    if(packageDropdown.hasClass('is-active')){
        packageDropdownToggle(true);
    }else {
        packageDropdownToggle(false);
    }

});

//HANDLE DEBIT RADIO INPUT

var trainerSelected = false;
var trainerSelector = document.querySelector('.checkbox-trainer input[name="personal-trainer"]');

var checkDebitInput = function(e) {

    var hideDebitInput = true,
        giftSelected = false;

    var selectedPackageID = packagePurchaseForm.find('.package-selector input[name="select-package"]'),
        giftSelector = packagePurchaseForm.find('.checkbox-gift input[name="gift"]');

    var paymentRadioBlock = $('.package-purchase-form .info-block[data-info="payment_method"]'),
        paymentRadioDebit = paymentRadioBlock.find('input[name="payment_method"][value="debit"]'),
        paymentRadioNormal = paymentRadioBlock.find('input[name="payment_method"][value="normal"]');

    // console.log(selectedPackageID.val());

    if(selectedPackageID.val() !== ''){

        var packageHasDebitPayment = packagePurchaseForm.find('.package-selector .package[data-package-id="'+ selectedPackageID.val() +'"]').data('debit-package');
        var packageHasGift = packagePurchaseForm.find('.package-selector .package[data-package-id="'+ selectedPackageID.val() +'"]').data('gift');
        var packagePrice = packagePurchaseForm.find('.package-selector .package[data-package-id="'+ selectedPackageID.val() +'"]').data('package-price');
        var packageMonthCount = packagePurchaseForm.find('.package-selector .package[data-package-id="'+ selectedPackageID.val() +'"]').data('package-month-count');

    }

    if(giftSelector.is( ":checked" )){

        giftSelected = true;

    }

    if(packageHasDebitPayment && !giftSelected){
        hideDebitInput = false;
    }

    if(!packageHasGift) {
        giftSelector.prop('checked', false);

        $('.checkbox-gift').addClass('hide');
        $('.info-block[data-info=gift]').addClass('hide');
    } else {
        $('.checkbox-gift').removeClass('hide');
    }

    // console.log(packageHasDebitPayment);
    //
    // console.log(giftSelected);
    //
    // console.log(hideDebitInput);

    if (packageMonthCount) {
        $('.full-price').html((packageMonthCount * packagePrice) + ' Eur');

    } else {
        $('.full-price').html('');
    }

    if( paymentRadioDebit.closest('.radio').hasClass('style-box') ) {

        paymentRadioDebit.siblings('.explain').find('.price').html( packagePrice + ' <span class="format">€ / mėn</span>' );

    }

    // if( paymentRadioNormal.closest('.radio').hasClass('style-box') ) {
    //
    //     var tempCount = packageMonthCount ? packageMonthCount : 1;
    //
    //     // console.log(tempCount);
    //
    //     paymentRadioNormal.siblings('.explain').find('.price').html( packagePrice * tempCount + ' <span class="format">€</span>' );
    //
    // }

    if(hideDebitInput){

        // paymentRadioNormal.prop('checked', true).trigger('change');

        var closestCol = paymentRadioDebit.closest('.col');

        if( closestCol.hasClass('row') ) {

            closestCol.addClass('hide');

        }else {

            closestCol.addClass('fadeout');

        }

    } else {

        $('.month-price').html(packagePrice);

        // paymentRadioDebit.prop('checked', true).trigger('change');
        paymentRadioDebit.closest('.col.row.hide, .col.fadeout').removeClass('hide fadeout');

    }

};

//SELECT PACKAGE

if ($('.additional-text').length > 0) {
    var defaultAdditionalText = $('.additional-text').data('default');
    // console.log(defaultAdditionalText)
}

// packageDropdown.find('.package-list .package').on('click', function (e) {
//
//     var selectedPackage = $(this),
//         selectedPackagePostId = selectedPackage.data('package-id'),
//         selectedPackageDebitPayment = selectedPackage.data('debit-package'),
//         selectedPackageGift = selectedPackage.data('gift'),
//         selectedPackageAllClubs = selectedPackage.data('all-clubs'),
//         selectedPackageHtml = selectedPackage.find('.text').html();
//
//     var isGiftSelected = packagePurchaseForm.find('.checkbox-gift input[name="gift"]').is( ":checked" );
//
//     if ($('.additional-text').length > 0) {
//         if (selectedPackageAllClubs !== '') {
//             $('.additional-text').html(selectedPackageAllClubs);
//         } else {
//             $('.additional-text').html(defaultAdditionalText);
//         }
//     }
//
//     packageToggleBlock.find('.text').html(selectedPackageHtml);
//
//     setTimeout(function () {
//         setSlickHeight(packagePurchaseFormSlick);
//     }, 100);
//
//     packageInput.val(selectedPackagePostId).trigger('change');
//
//     checkDebitInput();
//
//     packageDropdownToggle(true);
//
// });

//GIFT SWITCH

var giftSwitch = packagePurchaseForm.find('.checkbox-gift'),
    giftSwitchCheckbox = giftSwitch.find('input'),
    giftBlock = $('.package-purchase-form .info-block[data-info="gift"]'),
    memberBlock = paymentMethodBlock = $('.package-purchase-form .info-block[data-info="member"]');

giftSwitchCheckbox.on('change', function () {

    giftSwitch.addClass('switching');
    giftBlock.addClass('switching');
    // memberBlock.addClass('switching');

    checkDebitInput();

    if(giftSwitchCheckbox.is( ":checked" )){

        $('input[name=payment_method][value=normal]').click();

        // switchCartGift(giftSwitch.data('cart'), giftSwitch.data('item'), true);

        memberBlock.find('.name').text('Mokėtojo informacija');

        giftBlock.css('height', 0).css('height', giftBlock.children().outerHeight()).one(transitionEvent, function (e) {

            packagePurchaseForm.addClass('gift-selected');
            giftSwitch.removeClass('switching');
            giftBlock.removeClass('switching hide').removeAttr('style');

            setTimeout(function () {
                setSlickHeight(packagePurchaseFormSlick);
            }, 100)

        });

        // memberBlock.css('height', memberBlock.children().outerHeight()).css('height', 0).one(transitionEvent, function (e) {
        //
        //     memberBlock.removeClass('switching').addClass('hide').removeAttr('style');
        //
        //     memberBlock.find('.input.error').removeClass('error');
        //     memberBlock.find('.error-explain').remove();
        //
        //     setTimeout(function () {
        //         setSlickHeight(packagePurchaseFormSlick);
        //     }, 100)
        //
        // });

    }else {

        memberBlock.find('.name').text('Nario informacija');

        giftBlock.css('height', giftBlock.children().outerHeight()).css('height', 0).one(transitionEvent, function (e) {

            // switchCartGift(giftSwitch.data('cart'), giftSwitch.data('item'), false);

            packagePurchaseForm.removeClass('gift-selected');
            giftSwitch.removeClass('switching');
            giftBlock.addClass('hide').removeAttr('style');

            setTimeout(function () {
                setSlickHeight(packagePurchaseFormSlick);
            }, 100)

        });

        // memberBlock.css('height', 0).css('height', memberBlock.children().outerHeight()).one(transitionEvent, function (e) {
        //
        //     memberBlock.removeClass('switching hide').removeAttr('style');
        //
        //     setTimeout(function () {
        //         setSlickHeight(packagePurchaseFormSlick);
        //     }, 100)
        //
        // });
    }

});

//PAYMENT METHOD SWITCH

var paymentMethodBlock = $('.package-purchase-form .info-block[data-info="payment_method"]'),
    paymentMethodRadio = paymentMethodBlock.find('input[name="payment_method"]'),
    paymentMethodInputBlock = paymentMethodBlock.find('.debit-info'),
    paymentRestBlock = $('.package-purchase-form .info-block[data-info="rest"]');

paymentMethodRadio.on('change', function (e) {

    var radioVal = paymentMethodBlock.find('input[name="payment_method"]:checked').val();

    var checkedRadioBoxes = paymentMethodBlock.find('.radio.style-box.checked');

    if( checkedRadioBoxes.length ) {
        checkedRadioBoxes.removeClass('checked');
    }

    var radioBox = $(this).closest('.radio.style-box');

    if( radioBox.length ) {
        radioBox.addClass('checked');
    }

    paymentMethodBlock.addClass('switching');

    paymentRestBlock.removeClass('hide');
    memberBlock.removeClass('hide');


    if(radioVal === 'debit'){

        if(!paymentMethodInputBlock.hasClass('hide')){
            paymentMethodBlock.removeClass('switching');

            return false;
        }

        paymentMethodInputBlock.css('height', 0).css('height', paymentMethodInputBlock.children().outerHeight()).one(transitionEvent, function (e) {

            // $('.discount-code-wrap').hide();
            paymentMethodInputBlock.removeClass('hide').removeAttr('style');

            paymentMethodBlock.removeClass('switching');

            paymentMethodBlock.closest('form').addClass('debit-payment-selected');

            setTimeout(function () {
                setSlickHeight(packagePurchaseFormSlick);
            }, 100)

        })

    }else {

        if(paymentMethodInputBlock.hasClass('hide')){
            paymentMethodBlock.removeClass('switching');

            return false;
        }

        paymentRestBlock.find('.checkboxes .for-debit-payment.error').removeClass('error').find('.error-explain').remove();

        paymentMethodInputBlock.css('height', paymentMethodInputBlock.children().outerHeight()).css('height', 0).one(transitionEvent, function (e) {

            // $('.discount-code-wrap').show();
            paymentMethodBlock.closest('form').removeClass('debit-payment-selected');

            paymentMethodInputBlock.addClass('hide').removeAttr('style');

            paymentMethodInputBlock.find('.input.error').removeClass('error');
            paymentMethodInputBlock.find('.error-explain').remove();

            paymentMethodBlock.removeClass('switching');

            setTimeout(function () {
                setSlickHeight(packagePurchaseFormSlick);
            }, 100)

        })

    }

});

function switchCartGift(cart, item, gift) {
    pd = new FormData();
    pd.append('action', 'switch_cart_gift');
    pd.append('cart-reservation-code', cart);
    pd.append('item', item);
    pd.append('is-gift', gift);

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {
            if (response.success) {
                giftSwitch.removeClass('switching');
            }
        }
    });
}

// DISCOUNT CODE LOGIC

var discountActivated = false;

$('.discount-submit').on('click', function () {
    var discountCode = $('input[name=discount-code]').val();
    var debitId = $('input[name=debit-id]').val();
    var discountCodeWrap = $('.discount-code-wrap');
    var discountStatus = $('.discount-status');
    discountStatus.html('').removeClass('discount-error');

    var cart = discountCodeWrap.data('cart');
    var packageId = discountCodeWrap.data('package');

    if (discountCode && !discountActivated) {
        discountCodeWrap.addClass('loading');

        pd = new FormData();
        pd.append('action', 'validate_discount_code');
        pd.append('cart-reservation-code', cart);
        pd.append('discount-code', discountCode);
        pd.append('package-id', packageId);
        pd.append('debit-id', debitId);

        $.ajax({
            type: 'POST',
            url: postre['ajax_url'],
            data: pd,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {
                if (response.success) {
                    discountCodeWrap.removeClass('loading').addClass('inactive');
                    discountStatus.html('Kodas aktyvuotas');
                    discountActivated = true;
                    $('input[name=payment_method][value=normal]').next().find('.price').append('<span class="old-price">' + $('input[name=payment_method][value=normal]').data('price') + '€</span>');
                    $('input[name=payment_method][value=normal]').next().find('.price span:first-child').html(response.data.total);
                    $('input[name=payment_method][value=normal]').next().find('.price').addClass('grow');
                    $('input[name=discount-code-id]').val(response.data.id);

                    if (response.data.total_debit) {
                        $('input[name=payment_method][value=debit]').next().find('.price').append('<span class="old-price">' + $('input[name=payment_method][value=debit]').data('price') + '€</span>');
                        $('input[name=payment_method][value=debit]').next().find('.price span:first-child').html(response.data.total_debit);
                        $('input[name=payment_method][value=debit]').next().find('.price').addClass('grow');
                    }

                } else {
                    discountCodeWrap.removeClass('loading');
                    discountStatus.html(response.data).addClass('discount-error');
                }
            }
        });

    } else {
        discountStatus.html('Neteisingai įvestas kodas').addClass('discount-error');
    }
});

//PURCHASE FORM LOGIC

var purchaseFormInputs = $('input, select');

purchaseFormInputs.on('change keyup keydown keypress', function(){

    var wrap = $(this).closest('.input, .checkbox-wrap, .package-selector');

    wrap.removeClass('error');

    wrap.find('.error-explain').remove();

    // if($(this).attr('name') === 'bank_acc') {
    //     var newValue = $(this).val().replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
    //
    //     $(this).val( newValue );
    // }

    setTimeout(function () {
        setSlickHeight(packagePurchaseFormSlick);
    }, 100)

});

packagePurchaseForm.find('.purchase-carousel').on('click', '.button[data-slide-back]', function () {

    $(this).closest('.purchase-carousel').slick('slickGoTo', 0);

    packagePurchaseForm.data('submit-step', 'first');
});

packagePurchaseForm.on('submit', function (e) {
    e.preventDefault();

    var form = $(this),
        carousel = form.find('.purchase-carousel'),
        inputs = form.find('.input, .checkbox-wrap'),
        ready = true;

    for(var a=0; a<inputs.length; a++){
        if(inputs.eq(a).hasClass('error')){
            ready = false;
        }
    }

    if(trainerSelector.checked){
        trainerSelected = true;
    } else {
        trainerSelected = false;
    }

    if(!ready){
        return false;
    }

    packagePurchaseForm.addClass('loading');

    var data = form.serialize();

    if(typeof form.data('submit-step') === 'undefined'){
        form.data('submit-step', 'first');
    }

    pd = new FormData();
    pd.append('action', 'validate_purchase_form');
    pd.append('data', data);
    pd.append('cart-reservation-code', $('.discount-code-wrap').data('cart'));
    pd.append('step', form.data('submit-step'));
    pd.append('trainer', trainerSelected);

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {

            // console.log(response)

            var data = response.data;

            if(data.hasErrors){

                var errors = data.errors;

                for(var a=0; a<errors.length; a++){
                    var error = errors[a];

                    var input = form.find('[name='+ error['input'] +']');

                    var wrap = input.closest('.input, .checkbox-wrap, .package-selector');

                    wrap.addClass('error');

                    wrap.prepend('<div class="error-explain">'+ error['error'] +'</div>');
                }

                form.data('submit-step', 'first');

                carousel.slick('slickGoTo', 0).slick('slickRemove', 1);

                setTimeout(function () {
                    setSlickHeight(packagePurchaseFormSlick);
                }, 100);

                packagePurchaseForm.removeClass('loading');

            }else if(data.redirect){

                window.location.href = data.redirectUrl;


            }else if(data.html !== ''){

                carousel.slick('slickRemove', 1);

                carousel.slick('slickAdd', '<div class="slick-slide"><div>'+ data.html +'</div></div>').slick('next');

                packagePurchaseForm.removeClass('loading');

                form.data('submit-step', 'second');

            }
        }
    });

});

//HANDLE USER LOGIN

$('.self-service-login form input').on('change keyup keydown keypress', function (e) {

    $(this).parent().removeClass('error').find('.error-explain').remove();

});

$('.self-service-login .window.login form').on('submit', function (e) {
    e.preventDefault();

    var errors = [];

    var form = $(this),
        inputs = form.find('input');

    if(form.find('.input.error').length > 0){
        return false;
    }

    for(var a=0; a<inputs.length; a++) {
        var input = inputs.eq(a),
            validInput = true,
            error = '';

        if(input.attr('name') === 'email'){
            var re = /\S+@\S+\.\S+/;

            if(!(re.test(input.val().toLowerCase()))){
                validInput = false;
            }

            if(input.val() === ''){
                validInput = false;
            }

            if(!validInput) {
                error = 'Neteisingai įvestas el.paštas';
            }
        }

        if(input.attr('name') === 'password'){

            if(input.val() === ''){
                validInput = false;
            }

            if(!validInput) {
                error = 'Neteisingai įvestas slaptažodis';
            }
        }

        if(!validInput){
            errors.push({'name': input.attr('name'), 'error': error});
        }
    }

    var handleErros = function (arr) {
        for(var b=0; b<arr.length; b++){
            var errorArr = arr[b];

            form.find('input[name="'+ errorArr.name +'"]').parent().addClass('error').prepend('<div class="error-explain">'+ errorArr.error +'</div>');
        }
    };

    if(errors.length > 0){

        handleErros(errors)

    }else {

        var data = $(this).serialize();

        form.addClass('loading');

        pd = new FormData();
        pd.append('action', 'validate_user_login');
        pd.append('data', data);

        $.ajax({
            type: 'POST',
            url: postre['ajax_url'],
            data: pd,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {

                // form.removeClass('loading');

                if(response.success){

                    var token = response.data.token;

                    setCookie('re_service_token', token, 365);

                    window.location.href = $('.window.login button[type=submit]').data('after-login');

                }else {

                    form.removeClass('loading');

                    var err = response.data.code;

                    if(err){
                        if(err === 7602) {

                            handleErros(response.data.errors);

                        }
                    }

                }
            }
        })
    }
});

$('.self-service-login .window.forgot-pass form').on('submit', function (e) {

    e.preventDefault();

    var form = $(this),
        input = form.find('input');

    if(form.find('.input.error').length > 0){
        return false;
    }

    var error = '',
        validInput = true;

    var re = /\S+@\S+\.\S+/;

    if(!(re.test(input.val().toLowerCase()))){
        validInput = false;
    }

    if(input.val() === ''){
        validInput = false;
    }

    if(!validInput) {
        error = 'Neteisingai įvestas el.paštas';
    }

    if(!validInput){

        form.find('input').parent().addClass('error').prepend('<div class="error-explain">'+ error +'</div>');

    }else {

        var data = $(this).serialize();

        form.addClass('loading');

        pd = new FormData();
        pd.append('action', 'recover_user_pass');
        pd.append('data', data);

        $.ajax({
            type: 'POST',
            url: postre['ajax_url'],
            data: pd,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {

                form.removeClass('loading');

                if(Boolean(response.success)){

                    var loginBoxInner = form.closest('.login-box-inner'),
                        window = form.closest('.window'),
                        windowSuccess = $('.self-service-login .window.pass-success'),
                        windowSuccessInner = windowSuccess.find('.window-inner');

                    window.addClass('pre-hide');
                    loginBoxInner.css('height', window.outerHeight()).css('height', windowSuccessInner.outerHeight()).one(transitionEvent, function (e) {
                        window.addClass('hide').removeClass('pre-hide').removeAttr('style');

                        windowSuccess.removeClass('hide').one(transitionEvent, function () {
                            loginBoxInner.removeAttr('style');
                        })
                    })

                }else {

                    var code = response.data.code;

                    if(code === 'bad_email'){

                        form.find('input').parent().addClass('error').prepend('<div class="error-explain">Neteisingai įvestas el.paštas</div>');

                    }else {

                        form.find('input').parent().addClass('error').prepend('<div class="error-explain">Vartotojas nerastas</div>');

                    }

                }
            }
        })
    }
});

var scheduleCard = $('.schedules .weeks-carousel .card');

$('body').on('click', 'a[data-reserve-workout]', function (e) {

    btn = $(this);

    btn.addClass('loading');

    var card = btn.closest('.card');

    pd = new FormData();
    pd.append('action', 'reserve_user_workout');
    pd.append('procedure_id', card.data('workout-id'));
    pd.append('trainer_id', card.data('couch'));
    pd.append('begins', card.data('workout-begin'));
    pd.append('ends', card.data('workout-ends'));
    pd.append('subdivision_id', card.data('subdivision-id'));

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {

            var confirmBox = btn.closest('.confirm-box');

            btn.removeClass('loading');
            confirmBox.removeClass('active');

            if(response.success){

                confirmBox.siblings('a[data-reserve-workout-confirmation]').replaceWith(response.data.html);

                card.attr('data-reserved', 'true').attr('data-reservation', response.data.reservation_code);

                card.removeClass('active').one(transitionEvent, function (e) {

                    confirmBox.remove();

                });

                var capacity = card.find('.capacity .free').eq(0).text();

                var newCapacity = +capacity + 1;

                card.find('.capacity .free').text(newCapacity);

            }else {

                card.removeClass('active');

            }

            // if(response.success){
            //
            //     btn.replaceWith(response.data.html);
            //
            //     card.attr('data-reserved', 'true');
            //
            //     card.attr('data-reservation', response.data.reservation_code);
            //
            //     var capacity = card.find('.capacity .free').eq(0).text();
            //
            //     var newCapacity = +capacity + 1;
            //
            //     card.find('.capacity .free').text(newCapacity);
            //
            // }
            //
            // card.removeClass('active');
            // btn.removeClass('loading')

        }
    })

});

$('body').on('click', 'a[data-cancel-workout-confirmation], a[data-reserve-workout-confirmation]', function (e) {

    $(this).siblings('.confirm-box').addClass('active');

});

$('body').on('click', 'a[data-keep-workout]', function (e) {

    $(this).closest('.confirm-box').removeClass('active');

});

$('body').on('click', 'a[data-cancel-workout]', function (e) {

    btn = $(this);

    btn.addClass('loading');

    var card = btn.closest('.card');

    pd = new FormData();
    pd.append('action', 'cancel_user_workout');
    pd.append('reservation', card.attr('data-reservation'));

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {

            var confirmBox = btn.closest('.confirm-box');

            btn.removeClass('loading');
            confirmBox.removeClass('active');

            if(response.success){

                confirmBox.siblings('a[data-cancel-workout-confirmation]').replaceWith(response.data.html);

                card.attr('data-reserved', 'false').attr('data-reservation', 'false');

                card.removeClass('active').one(transitionEvent, function (e) {

                    confirmBox.remove();

                });

                var capacity = card.find('.capacity .free').eq(0).text();

                var newCapacity = +capacity - 1;

                card.find('.capacity .free').text(newCapacity);

            }else {

                card.removeClass('active');

            }
        }
    })

});

//HANDLE MY PROFILE FORM

var myProfileForm = $('.my-profile form');

myProfileForm.on('submit', function (e) {

    e.preventDefault();

    var inputsError = myProfileForm.find('.input.error');

    if(inputsError.length > 0) {
        return false;
    }

    myProfileForm.addClass('loading');

    var oldPass = myProfileForm.find('input[name=old-pass]'),
        newPass = myProfileForm.find('input[name=new-pass]'),
        newPassConfirm = myProfileForm.find('input[name=new-pass-confirm]'),
        newsletter = myProfileForm.find('input[name=checkbox-newsletter]').is(':checked');

    var error = false,
        errors = [];

    if(oldPass.val().length > 0 || newPass.val().length > 0 || newPassConfirm.val().length > 0) {

        if(oldPass.val() === ''){
            error = true;

            errors.push({
                'name': 'old-pass',
                'label': 'Neteisingas senas slaptažodis'
            });
        }

        if(newPass.val() === ''){
            error = true;

            errors.push({
                'name': 'new-pass',
                'label': 'Neįvestas naujas slaptažodis'
            });

        }else if(newPass.val().length < 8) {
            error = true;

            errors.push({
                'name': 'new-pass',
                'label': 'Slaptažodį turi sudaryti ne mažiau kaip 8 simboliai'
            });

        }

        if(newPass.val() !== newPassConfirm.val()){
            error = true;

            errors.push({
                'name': 'new-pass-confirm',
                'label': 'Slaptažodis nesutampa'
            });
        }

    }


    if(error){

        errors.forEach(function (error, index) {

            // console.log(error);

            myProfileForm.find('input[name="'+ error.name +'"]').closest('.input').addClass('error').prepend('<div class="error-explain">'+ error.label +'</div>');

        });

        myProfileForm.removeClass('loading');

    }else {

        pd = new FormData();
        pd.append('action', 'update_user_profile');
        pd.append('old', window.btoa(oldPass.val()));
        pd.append('new', window.btoa(newPass.val()));
        pd.append('new_confirm', window.btoa(newPassConfirm.val()));
        pd.append('newsletter', newsletter);

        $.ajax({
            type: 'POST',
            url: postre['ajax_url'],
            data: pd,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {

                // console.log(response);

                if(response.success){

                    oldPass.val('');
                    newPass.val('');
                    newPassConfirm.val('');

                    myProfileForm.removeClass('loading');

                }else {

                    response.data.forEach(function (error, index) {

                        // console.log(error);

                        myProfileForm.find('input[name="'+ error.name +'"]').closest('.input').addClass('error').prepend('<div class="error-explain">'+ error.label +'</div>');

                    });

                    myProfileForm.removeClass('loading');

                }

            }
        })

    }

});

if ($('.my-profile form').length > 0) {

    var gp = new GPassParser();

    $('.gpass-submit').on('click', function () {

        myProfileForm.addClass('loading');
        $('.gpass-valid').html('');

        gp.parse(function (status, callback) {

            if (status === 0) {
                var pd = new FormData();
                pd.append('action', 'submit_gpass');
                pd.append('data', callback);

                $.ajax({
                    type: 'POST',
                    url: postre['ajax_url'],
                    data: pd,
                    dataType: 'json',
                    contentType: false,
                    processData: false,
                    success: function (response) {

                        if(response.success){

                            $('.gpass-valid').html('Įkeltas, galioja iki ' + response.data.data['spr_praleidziamas_iki']);

                            myProfileForm.removeClass('loading');

                        } else {

                            myProfileForm.removeClass('loading');
                            $('.gpass-valid').html('<span style="color: red;">Galimybių pasas netinkamas</span>');

                        }

                    }
                })
            } else {
                myProfileForm.removeClass('loading');
                $('.gpass-valid').html('<span style="color: red;">Galimybių pasas netinkamas</span>');

            }

        });
    });

}

//HANDLE USER ACTIVATION FORM

var userActivationForm = $('.user-activation form');

userActivationForm.on('submit', function (e) {

    e.preventDefault();

    userActivationForm.addClass('loading');

    var newPass = userActivationForm.find('input[name=new-pass]'),
        newPassConfirm = userActivationForm.find('input[name=new-pass-confirm]'),
        data = userActivationForm.find('input[name=validation_data]');

    var error = false,
        errors = [];

    if(newPass.val() === ''){
        error = true;

        errors.push({
            'name': 'new-pass',
            'label': 'Neįvestas naujas slaptažodis'
        });

    }else if(newPass.val().length < 8) {
        error = true;

        errors.push({
            'name': 'new-pass',
            'label': 'Slaptažodį turi sudaryti ne mažiau kaip 8 simboliai'
        });

    }

    if(newPass.val() !== newPassConfirm.val()){
        error = true;

        errors.push({
            'name': 'new-pass-confirm',
            'label': 'Slaptažodis nesutampa'
        });
    }


    if(error){

        errors.forEach(function (error, index) {

            // console.log(error);

            userActivationForm.find('input[name="'+ error.name +'"]').closest('.input').addClass('error').prepend('<div class="error-explain">'+ error.label +'</div>');

        });

        userActivationForm.removeClass('loading');

    }else {

        pd = new FormData();
        pd.append('action', 'new_user_activation');
        pd.append('new', window.btoa(newPass.val()));
        pd.append('new_confirm', window.btoa(newPassConfirm.val()));
        pd.append('data', data.val());

        $.ajax({
            type: 'POST',
            url: postre['ajax_url'],
            data: pd,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {

                if(response.success){
                    openServiceLoginBox();

                    newPass.val('');
                    newPassConfirm.val('');
                }

                userActivationForm.removeClass('loading');

            }
        })

    }

});

